import _ from 'lodash'
import Backbone from 'backbone'
import template from './new-slide-form.hbs'
import SlideForm from './slide-form'
import ObjectSelector from 'scoreboard/components/object-selector'
import formHelper from 'scoreboard/components/form-helper'
import FormView from 'scoreboard/components/form-view'
import i18n from 'scoreboard/components/i18n'
import NewBriefingForm from './new-briefing-form'
import appDisplay from 'scoreboard/components/app-display'
import Briefing from './briefing'
import deviceType from 'scoreboard/components/device-type'
import periodSelectorDisplayed from 'scoreboard/components/period-selector-displayed'
import config from 'scoreboard/components/config'
import HttpStatusCodes from 'http-status-codes'
import projects from 'scoreboard/projects/projects'
import unwrapModel from 'scoreboard/components/unwrap-model'
import globals from 'scoreboard/components/globals'
import resizeDialogContent from 'scoreboard/components/resize-dialog-content'

var NewSlideForm = Backbone.View.extend({

	// this.model is a Slide

	className: 'new-slide-form',

	tagName: 'form',

	events: {
		'click .add-briefing': 'addBriefing'
	},

	initialize: function (options = {}) {
		this.options = options
		this._slideForm = new SlideForm({
			model: this.model,
			itemContext: _.get(this.options, 'itemContext'),
			disableAutofocus: true
		})

		var NewSlideFormView = FormView.extend({
			test: this.test.bind(this)
		})

		this.formView = new NewSlideFormView({ el: this.el, submit: this.submit.bind(this) })
		this.formView.on('change', this._change.bind(this))

		// Start the object selector off with the current project (if there is one)
		// selected and the current org selected.
		this.options.organizationId = this.options.organizationId || globals.orgId
		this.options.projectId = this.options.projectId || projects.id

		let selectorOptions = {
			section: 'briefings',
			params: {
				modifyDomain: true
			},
			// #28855 Allow to send to other project briefings
			showProjectSelector: true,
			orgId: this.options.organizationId,
			projectId: this.options.projectId
		}

		// If we're adding a spectated object (ex. bookmarked) to a briefing, we
		// want to make sure to outfit the object selector with its project/org info
		// and not the project/org we're currently in.
		let spectated = this.options.spectated
		if (spectated) {
			selectorOptions.orgId = spectated.get('organizationId')
			selectorOptions.projectId = spectated.get('projectId')
		}

		this._objectSelector = new ObjectSelector(selectorOptions)

		this._objectSelector.on('select', this.formView.change.bind(this.formView))
		this._objectSelector.on('selectOrg', this.formView.change.bind(this))

		// When the objectSelector is loading (trees are loading), disable the
		// add-briefing button. Else, enable it.
		this._objectSelector.on('toggle:loading', loading => {
			this.$('.add-briefing').toggleClass('is-disabled', loading)
		})

	},

	render: function () {
		this.$el.html(template())
		this.$('.slide-form-container').prepend(this._slideForm.el)
		this._slideForm.render()
		this.$('.object-selector').replaceWith(this._objectSelector.el)
		this._objectSelector.render()

		this.$('[name=label]').prop('autofocus', true)

		this.formView.start()
		this._objectSelector.orgGardener.on('select', this._change.bind(this))
		this._objectSelector.on('empty', errView => {
			//#25727 hide add button if no permission or if on high side derep org
			let status = this._objectSelector.objectGardener.stream.statusCode
			let data = this._objectSelector.objectGardener.stream.responseJSON
			let hideAddButton = status == HttpStatusCodes.FORBIDDEN ||
				(config.replicationInputEnabled && data.dereplicated)
			this.$('.add-briefing').toggleClass('is-not-displayed', hideAddButton)
		})
		this._objectSelector.on('success', () => {
			this.$('.add-briefing').removeClass('is-not-displayed')
		})

		if (!periodSelectorDisplayed(this.options.itemContext)) {
			this.$('.period-panel').addClass('is-not-displayed')
		}

		return this
	},

	resize: function(maxHeight) {
		let container = this.$('.choose-briefing')
		let objectSelector = container.find('.object-selector')
		objectSelector.css('height', '') // Reset needed for calculations
		this._objectSelector.resize()
		resizeDialogContent({
			dialog: this.el,
			maxHeight,
			target: container.find('.panel'),
			minHeight: 250,
			container: container[0]
		})
		objectSelector.css('height', '100%')
	},

	_change: function() {
		if (this._bbSelected()) {
			this.$el.removeClass('has-error')
		} else {
			this.formView.primaryButton.disable()
		}
	},

	_bbSelected: function() {
		return _.result(this._objectSelector.selected(), 'type') === 'briefing'
	},

	addBriefing: function() {
		// If the object selector is still loading, we can't add beiefings yet
		if (!this._objectSelector.treesRendered()) {
			return
		}

		let { projectId, organizationId } = this._objectSelector.getSelectedState()

		// If projects are enabled (one is selected automatically), we need to make
		// sure we select the appropriate organization depending on the selected
		// state of the object selector #30709
		if (projectId) {
			let noOrgSelected = _.isNil(organizationId)
			// If the selected project is the project we're currently in,
			// and if we haven't selected an org yet, select the org we're currently in
			if (projectId == projects.id && noOrgSelected) {
				organizationId = globals.orgId
			// If the selected project is not the one we're currently in, and
			// no org is selected, we need to select an org automatically.
			} else if (noOrgSelected) {
				this._objectSelector.selectProject(projectId)
				this._objectSelector.renderGardeners()
				organizationId = _.get(unwrapModel(projects.get(projectId)), 'orgId')
			}
		// If there's no project, go ahead with the selected org, or the global
		// org if there's no org selected for some reason.
		} else {
			organizationId = organizationId || globals.orgId
		}

		var briefing = new Briefing({
			organizationId,
			type: 'briefing',
			relativeId: _.get(this._objectSelector.selected(), 'id')
		})
		var position = this._objectSelector.objectGardener.getAddPosition(
			briefing, briefing.get('relativeId'))
		briefing.set(position)
		var form = new NewBriefingForm({ model: briefing })
		appDisplay.dialog(form)
		// after adding a briefing...
		this.listenTo(form, 'done', function(model) {
			// show the tree and hide the "no briefings" message in the selector
			this._objectSelector._onObjectSuccess(model.attributes)
			// Stop the search before showing showing the newly added node
			this._objectSelector._onFind(this._objectSelector.objectGardener.bind(this), null)
		})
		// automatically select the newly added briefing
		this.listenTo(Backbone, 'add:domain-object', function(model) {
			if (model === briefing) {
				this._objectSelector.select(model.id)
			}
		}.bind(this))
	},

	test: function() {
		if (!this._bbSelected()) {
			return i18n.get('briefingBooks.required')
		}
	},

	submit: function(e) {
		var data = formHelper.readFromDom(this.el)
		data.briefingId = this._objectSelector.selected().id
		return this.model.save(data, {
			patch: true,
			success: function() {
				Backbone.trigger('add:domain-object', this.model)
				this.trigger('done')
			}.bind(this)
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this._slideForm, this._objectSelector, this.formView], 'remove')
	}

})

export default NewSlideForm

NewSlideForm.__filename__ = 'briefings/new-slide-form.js'
